import { setPlayListIndex } from 'redux/actions/harmonizeActions'
import { setFetchStart } from 'redux/actions/fetchActions'
import { getMediaAudio, getMediaDisplay, getMediaThumbnail, getMediaVideo } from './imageUtils'
import { isNewFormat, MEDIA_TYPES } from './postUtils'
import { store } from 'index'
import { getMessage } from 'controllers/SocialServiceController'
import { setMessages, setPlayList } from 'redux/actions/messagesActions'
import { getAccountId } from 'redux/actions/accountActions'
import { setLikedPlayListIndex } from 'redux/actions/harmonizeActions'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { downloadImageFile } from 'controllers/BackblazeController'

/**
 * 
 * @param {*} mediaSource 
 * @param {*} sourceName 
 * @param {*} pub 
 * @param {*} legacy 
 * @returns 
 */
export const getAudioUrl = (source, sourceName, legacy) => {
    //console.log(`getAudioUrl source ${source} ${sourceName} ${legacy}`)
    const urlParameters = !legacy ? `${encodeURIComponent(source)}/${sourceName}/${process.env.REACT_APP_API_KEY}`
        : `${source}/${process.env.REACT_APP_API_KEY}`
    return !legacy ? `${process.env.REACT_APP_CORE_SERVICE}media/audio/${urlParameters}`
        : `${process.env.REACT_APP_CORE_SERVICE}media/audio/legacy/${urlParameters}`
}

export const getVideoUrl = (source, sourceName) => {
    const videoParameters = `${process.env.REACT_APP_API_KEY}/${source}/${sourceName}`
    return `${process.env.REACT_APP_CORE_SERVICE}media/${videoParameters}`
}

/**
 * Immediately after building the playList entry, download the display or thumbnail image, if any.
 * This should prepopulate the disc cache for when the entry is actuall displayed on screen.
 * @param {*} media 
 * @param {*} name 
 */
const downloadEntryImages = async (media, name) => {
    let imageMedia = getMediaDisplay(media)
    if (!imageMedia) {
        imageMedia = getMediaThumbnail(media)
    }
    if (imageMedia) {
        const { source } = imageMedia
        try {
            await downloadImageFile(source)
            console.log(`downloadEntryImages downloaded ${name}`)
        } catch (error) {
            console.error(`downloadEntryImages error downloading ${source} IGNORED`, error)
        }
    }
}

/**
 * Builds the URL parameters for the audio or video and returns that and some other things
 * @param {*} md 
 * @param {*} newFormat   True for any audio created after some date
 * @returns { mimeType, duration, source: url, sourceName, mediaSource }
 */
const buildEntryMedia = (md, newFormat) => {
    let url
    const { source: mediaSource, mimeType, imageType, sourceName, duration } = md
    switch (mimeType) {
        case 'audio/mpeg':
            url = getAudioUrl(mediaSource, sourceName, !newFormat)
            break
        case 'video/mp4':
            //:apiKey/:username/:foldername/:subfoldername/:videoname
            //mediaSource is e.g. cjvilla-photo/home/PerfectLife and is defined when Message is stored on Core Service
            url = getVideoUrl(mediaSource, sourceName)
            break
        default:
            break
    }
    //console.log(`buildEntryMedia completed mimeType ${mimeType} ${url}`, md)
    return { mimeType, imageType, duration, source: url, sourceName, mediaSource }

}

const buildAllEntryMedia = (msg, entryMedia) => {
    //console.log('buildAllENtryMedia', msg)
    const { _id: messageId, name, media, createdAt, username } = msg

    media.forEach((md) => {
        const msgMedia = buildEntryMedia(md, isNewFormat(msg))
        const { mimeType, imageType, duration, source: url, sourceName, mediaSource } = msgMedia
        entryMedia.push({ messageId, name, createdAt, mimeType, imageType, duration, source: url, sourceName, username, mediaSource })
    })

}

/**
 * Convert the Message into a playList entry. The playListEntry as a minimum must have 
 * all of the Message, plus the Message _id as messageId. This is some old thinking from
 * the days when Messages could exist without streaming media. Note that every playListEntry
 * has *both* _id and messageId, because the original message (with _id) is spread into it.
 * @todo Carefully get rid of Message/playList distinction
 * @param {*} message
 */
export const buildPlaylistEntry = (message) => {
    const { _id: messageId, media, name } = message
    let playListEntry = { ...message, messageId }
    if (media && media.length) {
        let entryMedia = []
        buildAllEntryMedia(message, entryMedia)
        const hasPlayableMedia = entryMedia.findIndex(em => MEDIA_TYPES.AUDIO.includes(em.mimeType)
            || MEDIA_TYPES.VIDEO.includes(em.mimeType)) !== -1
        if (hasPlayableMedia) {
            playListEntry = {
                ...message, messageId, entryMedia
            }
            downloadEntryImages(entryMedia, name)
        }
    }
    return playListEntry
}

/**
 * Build playList from newMessages.
 * 
 * Note that we no longer filter messages based on categoryMode -- this is only done
 * when messages are fetched from Social Service.
 * @param {*} newMessages 
 * @returns 
 */
export const buildNewPlaylistEntries = (newMessages) => { //, categoryMode = CATEGORY_MODES.ALL_MEDIA) => {
    console.log(`buildNewPlaylistEntries ${newMessages.length} `, newMessages)
    const updatedPlayList = []
    newMessages.forEach((m) => {
        updatedPlayList.push(buildPlaylistEntry(m))
    })
    return updatedPlayList
}

export const getAudioSrc = (song) => {
    if (song) {
        const { entryMedia } = song
        const audioMedia = getMediaAudio(entryMedia)
        let audioSrc
        if (audioMedia) {
            const { source } = audioMedia
            audioSrc = source
        }
        return audioSrc
    } else {
        return null
    }
}

export const getVideoSrc = (song) => {
    let videoSrc
    if (song) {
        const { entryMedia } = song
        const videoMedia = getMediaVideo(entryMedia)

        if (videoMedia) {
            const { source: videoSource } = videoMedia
            videoSrc = videoSource
        }
    }
    return videoSrc
}

export const getCurrentPlaylistEntry = () => {

    const { playList } = store.getState().messages
    if (playList.length) {
        const { playListIndex } = store.getState().harmonize
        return playList[playListIndex]
    }
    else {
        return null
    }
}

export const getCurrentPlaylistName = () => {
    const entry = getCurrentPlaylistEntry()
    if (entry) {
        const { name } = entry
        return name
    } else {
        return 'No name'
    }
}

/**
 * 
 * @returns True if there is another playList entry without performing a fetch
 */
export const hasNext = () => {
    const { playListIndex } = store.getState().harmonize
    const { playList } = store.getState().messages
    return playListIndex + 1 < playList.length
}

export const isPrivatePlaylistEntry = () => {
    const entry = getCurrentPlaylistEntry()
    if (entry) {
        const { accessType } = entry
        return accessType === ACCESS_TYPES.PRIVATE
    } else {
        return false
    }
}

/** Messages lookahead is process.env.REACT_APP_FETCH_BLOCK_SIZE.
 * 
 * If we have not reached the endOfMessages, compare the next playListIndex request
 * to the current playList length-the fetch block size. If the request exceeds
 * that value, setFetchStart to playList.length so that 
 * whoever is listening to that (currently just HarmonizeHome) fetches another block of messages.
 */
export const next = (dispatch, checkSwipe = false) => {
    const { allowSwipe } = store.getState().display
    console.log(`(*) next allowSwipe ${allowSwipe}`)
    if (!checkSwipe || allowSwipe) {
        const blockSize = parseInt(process.env.REACT_APP_FETCH_BLOCK_SIZE)
        const { playListIndex } = store.getState().harmonize
        const { endOfMessages, playList } = store.getState().messages
        console.log(`(*) next endOfMessages ${endOfMessages} playListIndex ${playListIndex} playList length ${playList.length}`)
        if (!endOfMessages && playListIndex > playList.length - blockSize) {
            console.log(`playlistUtils next request fetch playListIndex ${playListIndex} fetchStart ${playList.length}`)
            dispatch(setFetchStart(playList.length))
        }
        if (playListIndex + 1 < playList.length) {
            dispatch(setPlayListIndex(playListIndex + 1))
        }
    }
}
export const nextBlock = (dispatch) => {
    console.log(`(*) nextBlock`)
    const { playListIndex } = store.getState().harmonize
    const { endOfMessages, playList } = store.getState().messages
    const blockSize = parseInt(process.env.REACT_APP_FETCH_BLOCK_SIZE)
    console.log(`(*) nextBlock endOfMessages ${endOfMessages} playListIndex ${playListIndex} playList length ${playList.length}`)
    if (!endOfMessages) {
        const start = playList.length + blockSize
        console.log(`playlistUtils next request fetch playListIndex ${playListIndex} fetchStart ${start}`)
        dispatch(setFetchStart(start))
    }
}

export const previous = (dispatch, checkSwipe = false) => {
    const { allowSwipe } = store.getState().display
    if (!checkSwipe || allowSwipe) {
        const { playListIndex } = store.getState().harmonize
        if (playListIndex - 1 > -1) {
            dispatch(setPlayListIndex(playListIndex - 1))
        }
    }
}

/**
 * If allowSwipe is true then set likedPlaylistIndex which triggers
 * SwipeCardOverlay addLikeToMessage.
 * @param {*} dispatch 
 */
export const setPlayListLiked = (dispatch) => {
    const { allowSwipe } = store.getState().display
    if (allowSwipe) {
        const { playListIndex } = store.getState().harmonize
        dispatch(setLikedPlayListIndex(playListIndex))
    }
}


/**
 * Get the referenced Message, then update the messages and playList
 * for the currentRoom with the retrieved Message.
 * @param {*} messageId 
 * @param {*} currentRoom 
 * @param {*} dispatch 
 * @throws Exception if getMessage fails or returns a null Message
 */
export const refetchMessage = async (messageId, currentRoom, dispatch) => {
    const message = await getMessage(messageId, getAccountId())
    if (message) {
        console.log(`refetchMessage got`, message)
        updateMessagesAndPlayList(message, currentRoom, dispatch)
    } else {
        throw new Error(`Unable to getMessage ${messageId}`)
    }

}
/** Empty the playList, set its index to 0,
 * and set fetchStart to -1.
 * This will cause a complete refetch using whatever categoryMode is. */
export const reset = (dispatch) => {
    dispatch(setPlayList([]))
    dispatch(setPlayListIndex(0))
    dispatch(setFetchStart(-1))
}

/**
 * If the messageToUpdate belongs to the currentRoom, then find it in messages
 * and playList, update and dispatch both.
 * @param {*} messageToUpdate Expects  _id
 * @param {*} currentRoom 
 * @param {*} dispatch 
 */
export const updateMessagesAndPlayList = (messageToUpdate, currentRoom, dispatch) => {
    console.log(`updateMessagesAndPlaylist messageToUpdate id ${messageToUpdate._id}`, messageToUpdate)
    const { roomId } = messageToUpdate
    const { _id } = currentRoom
    console.log(`...compare roomId ${roomId} to currentRoom ${_id}`)
    if (roomId === _id) {
        const { messages, playList } = store.getState().messages
        console.log(`...update proceeds, messages are`, messages)
        const messageIx = messages.findIndex((m) => m._id === messageToUpdate._id)
        const playListIx = playList.findIndex((m) => m._id === messageToUpdate._id)
        if (messageIx !== -1) {
            console.log(`...update message ${messageIx}`)
            const update = [
                ...messages.slice(0, messageIx),
                messageToUpdate,
                ...messages.slice(messageIx + 1),
            ]
            console.log(`...updated messages are`, update)
            dispatch(setMessages(update))
        }
        if (playListIx !== -1) {
            console.log(`...update playList ${playListIx}`)
            const newPlayListEntry = buildPlaylistEntry(messageToUpdate)
            const update = [
                ...playList.slice(0, playListIx),
                newPlayListEntry,
                ...playList.slice(playListIx + 1),
            ]
            console.log(`...updated playList is`, update)
            dispatch(setPlayList(update))
        }
    }
}